import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { EventEmitter } from 'fbemitter';
import $ from 'jquery';
import { compStatusTypes } from '../Constants';
import Utils from '../sources/Utils';
import ModalView from './ModalSet/ModalView';
import '../styles/Modal.less';
import configureStore from '../stores/Modal';
import { updateItemIndex, updateModalStatus } from '../actions/Modal';
import update from 'immutability-helper';

function dataParse(data) {
    if (data && !Array.isArray(data)) {
        data = [data];
    }
    return data;
}

let _data, _modal;
let _ModalList = [];

class Modal extends EventEmitter {
    constructor(data, option) {
        super();
        const { isCommon, theme } = option || {};
        let modalClassName = isCommon ? 'entrylmsModalCommon' : 'entrylmsModal';

        if (theme) modalClassName += ` ${theme}`;

        // 각 상속자 마다 store생성
        this.store = configureStore({}, this);
        const modal = $('<div>');
        let modalParent = $(`.${modalClassName}`);
        if (modalParent.length === 0) {
            modalParent = $('<div>');
            modalParent.addClass(modalClassName);
            $('body').append(modalParent);
        }

        _ModalList.push(this);

        modalParent.append(modal);
        this._data = dataParse(data);
        this._modal = modal;
        this._option = option;
        this._theme = theme;
    }

    static getModalList() {
        return _ModalList;
    }

    static getModalCount() {
        return _ModalList.length;
    }

    static hideAllModal() {
        _ModalList.forEach((_m) => {
            _m.hide();
        });
    }

    static clearModal() {
        $('.entrylmsModal').remove();
        _ModalList = [];
    }

    set itemIndex(idx) {
        if (Array.isArray(this._data)) {
            if (idx > -1 && idx < this._data.length) {
                this.store.dispatch(updateItemIndex(idx));
            } else if (idx <= -1) {
                this.store.dispatch(updateItemIndex(0));
            } else {
                this.store.dispatch(updateItemIndex(this._data.length - 1));
            }
        }
    }

    get itemIndex() {
        return this.store.getState().Modal.itemIndex;
    }

    set status(status) {
        this.store.dispatch(updateModalStatus(status));
    }

    get status() {
        return this.store.getState().Modal.status;
    }

    getIndexByKey(key) {
        return this._data.findIndex((item) => item.key === key);
    }

    show(target, data) {
        if (this.status !== compStatusTypes.ENABLED) {
            this.status = compStatusTypes.ENABLED;
        }
        if (Number.isInteger(target)) {
            this.itemIndex = target;
        } else if (target && typeof target === 'string') {
            this.itemIndex = this.getIndexByKey(target);
        } else {
            // index가 없을 경우 기본값인 index를 getter 에서 가져와 setter에 세팅
            this.itemIndex = this.itemIndex;
        }
        this.render(data);
        return this;
    }

    hide() {
        if (this.status !== compStatusTypes.HIDDEN) {
            this.status = compStatusTypes.HIDDEN;
        }
        // TODO: 감춰 졌을때 인덱스 초기화?
        // this.itemIndex = 0;
        // this.render();
        return this;
    }

    set modalData(data) {
        this._data = dataParse(data);
        this.render();
    }

    get modalData() {
        return this._data;
    }

    set modalOption(option) {
        this._option = option;
        this.render();
    }

    get modalOption() {
        return this._option;
    }

    render(data) {
        const item =
            data && this._data.length
                ? update(this._data, {
                      [this.itemIndex]: {
                          $merge: data,
                      },
                  })
                : this._data;
        render(
            <Provider store={this.store}>
                <ModalView
                    items={item}
                    emitter={this}
                    option={this._option}
                    theme={this._theme}
                />
            </Provider>,
            this._modal[0]
        );
    }

    on(eventType, callback) {
        this.addListener(eventType, callback);
        return this;
    }

    one(eventType, callback) {
        this.once(eventType, callback);
        return this;
    }

    off(eventType) {
        this.removeAllListeners(eventType);
        return this;
    }

    isShowing() {
        return this.status === compStatusTypes.ENABLED;
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./components/Modal.js